//Created as 2 separate files for header and footer to create chunks of them for faster loading

import React from "react";
import { createRoot } from "react-dom";
import Header from "./components/Header";

document.addEventListener("DOMContentLoaded", () => {
  // Render Header
  const mountNode1 = document.getElementById("react-header");
  if (mountNode1) {
    const root1 = createRoot(mountNode1);
    root1.render(<Header />);
  }
});
